import {
  Box,
  Dialog,
  DialogTitle,
  Grid,
  Paper,
  TextField,
  DialogContent,
  DialogContentText,
  Typography,
  DialogActions,
  Button,
  Loading,
} from "@mui/material";
import { ENDPOINTS } from "../../../config/endpoints";
import { useState } from "react";
import { putData } from "../../../../../services/library";
import useForm from "../../../../../Hooks/UseForm";
import moment from "moment";

export function ConfirmCorrectiveMaintenanceDialog({
  rowData,
  open,
  onClose,
  refetch,
  showToast,
}) {
  const initDataForm = {
    ejecuto: rowData.ejecuto || "",
    fecha_realizado: rowData.fecha_realizado
      ? moment(rowData.fecha_realizado).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD"),
    costo_materiales: rowData.costo_materiales || 0,
    otros_costos: rowData.otros_costos || 0,
    hrshombre: rowData.hrshombre || 0,
    observacionesOT: rowData.observacionesOT || "",
    observaciones: rowData.observaciones || "",
  };
  const { dataForm, handleChange } = useForm(initDataForm);
  const [isSubmiting, setisSubmiting] = useState(false);

  const onPutConfirmar = async (e) => {
    setisSubmiting(true);
    try {
      await putData(
        e,
        `${ENDPOINTS.CORRECTIVOS.BASE}/${rowData.id_correctivo}`,
        {
          realizado: 1,
          ejecuto: dataForm.ejecuto,
          fecha_realizado: dataForm.fecha_realizado,
          costo_materiales: dataForm.costo_materiales,
          otros_costos: dataForm.otros_costos,
          hrshombre: dataForm.hrshombre,
          observaciones: dataForm.observaciones,
        },
        () => {}
      );
      showToast("Mantenimiento confirmado correctamente", "success");
      await refetch();
    } catch (error) {
      console.error(error);
      showToast("Error al confirmar mantenimiento", "error");
    } finally {
      onClose();
      setisSubmiting(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth={"md"}>
        <DialogTitle>Confirmar Mantenimiento Correctivo</DialogTitle>
        <form onSubmit={onPutConfirmar}>
          <DialogContent dividers>
            <DialogContentText>
              ¿Estás seguro de que deseas marcar este correctivo como
              completado?
            </DialogContentText>

            <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
              <Typography variant="subtitle2">
                Detalles del Correctivo
              </Typography>
              <Box
                sx={{ mt: 1, display: "flex", flexDirection: "column", gap: 1 }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2" color="text.secondary">
                    Equipo afectado:
                  </Typography>
                  <Typography variant="body2" fontWeight="medium">
                    {rowData.equipo} ({rowData.id_equipo})
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2" color="text.secondary">
                    Zona:
                  </Typography>
                  <Typography variant="body2" fontWeight="medium">
                    {rowData.zona}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2" color="text.secondary">
                    Sector:
                  </Typography>
                  <Typography variant="body2" fontWeight="medium">
                    {rowData.sector}
                  </Typography>
                </Box>
                <Box sx={{ display: "block" }}>
                  <Typography variant="body2" color="text.secondary">
                    Tarea:
                  </Typography>
                  <Typography variant="body2">{rowData.tarea}</Typography>
                </Box>
              </Box>
            </Paper>
            <Grid container spacing={3} sx={{ mt: 2 }}>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="Ejecuto"
                  name="ejecuto"
                  focused
                  placeholder="Nombre del ejecutor"
                  required
                  value={dataForm.ejecuto}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="Fecha Realizado"
                  required
                  name="fecha_realizado"
                  type="date"
                  focused
                  value={dataForm.fecha_realizado}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="Costo de Materiales"
                  name="costo_materiales"
                  type="number"
                  focused
                  value={dataForm.costo_materiales}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  focused
                  label="Costo de Otras Actividades"
                  name="otros_costos"
                  type="number"
                  value={dataForm.otros_costos}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="Horas de Hombre"
                  name="hrshombre"
                  type="number"
                  focused
                  placeholder="Horas"
                  value={dataForm.hrshombre}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  label="Observaciones"
                  name="observaciones"
                  multiline
                  rows={3}
                  placeholder="Observaciones"
                  value={
                    dataForm.observacionesOT !== ""
                      ? dataForm.observacionesOT
                      : dataForm.observaciones
                  }
                  disabled={
                    rowData.observacionesOT !== "" &&
                    rowData.observacionesOT !== null
                  }
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button variant="outlined" onClick={onClose}>
              Cancelar
            </Button>
            <Button variant="contained" disabled={isSubmiting} type="submit">
              Confirmar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
